import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <Card className="w-full max-w-md border-slate-200">
        <CardContent className="p-8 text-center space-y-4">
          <XCircle className="w-10 h-10 text-slate-400 mx-auto" aria-hidden="true" />
          <p className="text-base font-bold text-slate-900">Checkout annullato</p>
          <p className="text-sm text-slate-600">
            Nessun addebito è stato effettuato. Puoi riprendere la scelta del piano in qualsiasi momento.
          </p>
          <Link to="/impostazioni">
            <Button variant="outline" data-testid="payment-cancel-back">Torna alle impostazioni</Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
